<template>
  <RexModalV3
    :show="true"
    @onClose="handleClose"
    :title="getFormTitle"
    width="90vw"
    :enableFooter="true"
  >
    <template #body>
      <div class="channel-modal-body">
        <div class="fields-and-table-box">
          <div
            class="m-body d-flex flex-column mb-1 flex-wrap channel-form-fields-box"
          >
            <div class="add-name-and-type d-flex flex-row align-items-start">
              <div class="d-flex flex-column">
                <div class="mb-lg-2 mb-xl-2">
                  <RexModalLabel
                    :primaryLabel="$t('channelName') + $t('asterisk')"
                  />
                </div>
                <div>
                  <RexModalInput
                    type="text"
                    placeholder
                    style="height: 2.5em; width: 23em"
                    v-model="channelName"
                    :modelValue="channelName"
                    id="input-channel-name"
                    :class="invalid.channelName ? 'mb-2' : ''"
                    @onFocusout="
                      (item) => {
                        isEdit = false;
                        validateChannelName(item);
                      }
                    "
                  />
                  <RexInfoLabel
                    :isError="true"
                    :customStyle="'max-width:fit-content !important;word-wrap:break-word;'"
                    v-if="invalid.channelName"
                    :info="notificationNameErrorInfo"
                  />
                </div>
              </div>
              <div class="d-flex flex-column channel-type-box">
                <div class="mb-lg-2 mb-xl-2">
                  <RexModalLabel :primaryLabel="$t('channelType')" />
                </div>
                <div>
                  <RexSearchSelect
                    :data="channelList"
                    :current="channelSelected"
                    :objectValueIndex="1"
                    width="23em"
                    @onChoose="selectChannel"
                    :isSearch="false"
                    v-model="channelType"
                    id="search-select-add-list-channel"
                    :disabled="isDisabled"
                  />
                  <RexInfoLabel
                    :isError="true"
                    customStyle="width:23em"
                    v-if="invalid.channelType"
                    :info="$t('selectChannelType')"
                  />
                </div>
              </div>
            </div>
            <div v-if="enableWebhookTemplate" class="data-field-box">
              <div class="data-label-field-box">
                <RexModalLabel
                  :primaryLabel="$t('notification.data')"
                  class="data-field-label"
                />
                <div class="data-tag-toggle-box">
                  <span>{{ $t('notification.tagging') }}</span>
                  <RexToggleCurvey
                    label=""
                    @valueChanged="onTaggingChange"
                    :defaultValue="isTagging"
                    class="toggle-tag-elem"
                  />
                </div>
              </div>
              <DataField
                @onTextChange="onDataTemplateChange"
                :editorValue="dataTemplate"
              />
              <RexInfoLabel
                v-if="invalidDataTemplate"
                :isError="true"
                :info="getWebhookTemplateErrMsg"
              />
            </div>
            <div class="d-flex flex-column mt-4">
              <div class="mb-lg-2 mb-xl-2">
                <RexModalLabel
                  :primaryLabel="
                    $t('enterChannelName') +
                    channelNameExtendedLable +
                    $t('asterisk')
                  "
                />
              </div>
              <div class="noti-add-channel-info">
                {{
                  $t('alertsTriggeredToSelectedChannelMessage', [
                    channelType != ''
                      ? channelType === 'email'
                        ? channelType + 's'
                        : channelType + ' channels'
                      : 'email',
                  ])
                }}
              </div>
              <div class="d-flex">
                <RexModalInput
                  type="text"
                  :placeholder="placeHolderTitle"
                  style="height: 2.5em; width: 30.5em"
                  class="channel-path"
                  v-model="channelPath"
                  id="input-widget-url"
                />
                <button
                  class="add-btn"
                  @click="addChannelPath"
                  id="btn-add-channel-path"
                  :disabled="invalid.channelPath ? true : false"
                  :class="
                    invalid.channelPath ? 'button-disabled' : 'button-primary'
                  "
                >
                  <BaseIcon name="filledAdd" width="2.5em" height="2.5em" />
                </button>
              </div>
              <div
                v-if="invalid.channelPath"
                class="noti-add-channel-type-err-msg"
              >
                {{ buildChannelPathErrorMessage() }}
              </div>
            </div>
            <div class="d-flex flex-column row-only-table-box mt-3">
              <RexRowOnlyTableComp
                :loading="loading"
                :items="channelItemsApp"
                :actions="actionsApp"
                :hideVerticalLine="true"
                highlight="secondary"
                height="auto"
                width="100%"
                :showNoData="false"
                @tableAction="actionOnChannelPath"
                :rowCustomStyle="rowCustomStyle"
                :headers="headers"
                :showHeaderRow="false"
                :tableRowProperties="{
                  showAleternateColor: false,
                  background: 'rgb(41,44,50)',
                  showFirstRowTopBorder: false,
                }"
              />
            </div>
          </div>
          <div class="channel-form-table-box">
            <VariablesInfoTable :isTagging="isTagging" />
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="add-channel-footer">
        <RexButtonV3 variant="default" @onClick="clear" id="btn-clr-channel">
          {{ $t('clear') }}
        </RexButtonV3>
        <RexButtonV3
          variant="primary"
          :disabled="getDisableBtn"
          @onClick="submitForm"
          id="btn-submit-channel"
        >
          {{ updateButtonText }}
        </RexButtonV3>
      </div>
    </template>
  </RexModalV3>
</template>

<script>
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import RexModalLabel from '@/rex-components/rex-modal-label.vue';
import RexModalInput from '@/rex-components/rex-modal-input.vue';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import RexRowOnlyTableComp from '@/rex-components/rex-row-only-table.vue';
import DataField from '@/components/Notification/channel-form/DataField.vue';
import VariablesInfoTable from '@/components/Notification/channel-form/VariablesInfoTable.vue';
import RexToggleCurvey from '@/rex-components/rex-toggle-curvey.vue';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import { notificationSucess, notificationError } from '@/utils/notification';
import {
  defaultWebHookTemplate,
  defaultTaggingWebhookTemplate,
} from '@/components/Notification/notification.type';
import format from '@/utils/messageFormat';
import { validateURL, validateEmail } from '@/utils/emailAndUrlValidator';
import {
  validateJson,
  getPrettyJSONStr,
  jsonParser,
} from '@/utils/helper-function';
import {
  TAGGING_TEMPLATE_TYPE,
  STANDARD_TEMPLATE_TYPE,
} from '@/components/Notification/notification.constant';

export default {
  name: 'AddChannelModal',
  components: {
    RexButtonV3,
    RexModalV3,
    RexModalLabel,
    RexModalInput,
    RexInfoLabel,
    RexSearchSelect,
    RexRowOnlyTableComp,
    DataField,
    VariablesInfoTable,
    RexToggleCurvey,
  },
  props: {
    isSecondaryPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stylingAddChannel: {
        height: '2.5rem',
        width: '7.375rem',
      },
      isEdit: false,
      rowCustomStyle: {
        'font-style': 'italic',
        'border-bottom': ' 0.3em solid #2e3032',
        background: 'rgb(30,32,33)',
        'padding-top': '0.3rem',
        'padding-bottom': '0.3rem',
        'padding-left': '1rem',
        'padding-right': '0rem',
      },
      loading: false,
      channelName: '',
      isDisabled: false,
      notificationNameErrorInfo: this.$t('channelNameValidation'),
      isDisabledButton: false,
      channelNameExtendedLable: this.$t('emailAddress'),
      dataTemplate: getPrettyJSONStr(defaultWebHookTemplate),
      invalidDataTemplate: false,
      channelPath: '',
      hasDuplicateItemInList: false,
      channelType: '',
      placeHolderTitle: this.$t('addEmailAddress'),
      updateButtonText: '',
      updatingChannelRecord: false,
      headers: [
        {
          showHeaderRow: true,
          key: 'name',
          name: this.$t('alertType'),
          width: '90%',
          sortable: false,
          routable: false,
          isEllipsisReq: true,
        },
        {
          showHeaderRow: true,
          type: 'actions',
          name: this.$t('action'),
          key: 'Actions',
          width: '10%',
        },
      ],
      channelItemsApp: [],
      actionsApp: [
        // We can enable once this feature is taken in upcoming sprints
        // {
        //   type: 'edit',
        //   key: ['editAlert'],
        //   icon: 'editFilled',
        // },
        {
          type: 'delete',
          key: ['deleteAlert'],
          icon: 'deleteFilled',
        },
      ],
      text: '',
      showModal: false,
      channelSelected: {},
      channelList: [
        {
          key: 'email',
          label: this.$t('email'),
          msg: this.$t('emailAddress'),
          placeHolder: this.$t('addEmailAddress'),
        },
        {
          key: 'slack',
          label: this.$t('slack'),
          msg: this.$t('slackURL'),
          placeHolder: this.$t('addSlackURL'),
        },
        {
          key: 'webhook',
          label: this.$t('webhook')
            .toLowerCase()
            .replace(/\b\w/g, (s) => s.toUpperCase()),
          msg: this.$t('webbookURL'),
          placeHolder: this.$t('addWebhookURL'),
        },
      ],
      invalid: {
        channelName: false,
        channelType: false,
        channelPath: false,
      },
      isTagging: false,
      arrayDataTemplateErrMsg: '',
    };
  },
  computed: {
    ...mapGetters('globalState/user', {
      userInfoGetter: 'getUserInfo',
    }),
    ...mapGetters('channelState/overview', ['getCurrentChannel']),
    enableWebhookTemplate() {
      return this.channelType === 'webhook';
    },
    getWebhookTemplateErrMsg() {
      return this.invalidDataTemplate
        ? this.arrayDataTemplateErrMsg || this.$t('notification.enterValidJson')
        : '';
    },
    getFormTitle() {
      return !this.isEdit
        ? this.$t('notification.addChannel')
        : this.$t('notification.editChannel');
    },
    getDisableBtn() {
      return this.channelItemsApp.length <= 0 || this.isDisabledButton;
    },
  },
  methods: {
    ...mapMutations('channelState/overview', [
      'setShowAddChannel',
      'setCurrentChannel',
      'setRefreshChannels',
    ]),

    ...mapActions('channelState/overview', [
      'SAVE_ALERT_RULE_CHANNEL',
      'SEARCH_EXISTING_NOTIFICATION_CHANNEL_NAME',
    ]),
    formatString(pattern, object) {
      return format(pattern, [object]);
    },
    validateChannelName(channelName) {
      if (
        this.channelName.length > 50 ||
        !this.channelName ||
        this.channelName.trim().length === 0 ||
        !/^( )?[a-zA-Z0-9]+( [a-zA-Z0-9]+)*( )?$/.test(this.channelName)
      ) {
        (this.notificationNameErrorInfo = this.$t('channelNameValidation')),
          (this.invalid.channelName = true);
        this.isDisabledButton = true;
      } else if (!/^( )?[a-zA-Z0-9]+( [a-zA-Z0-9]+)*( )?$/.test(channelName)) {
        (this.notificationNameErrorInfo = this.$t('alertInvalidCharacters')),
          (this.invalid.channelName = true);
        this.isDisabledButton = true;
      } else {
        if (!this.isEdit) {
          this.SEARCH_EXISTING_NOTIFICATION_CHANNEL_NAME(channelName)
            .then((response) => {
              if (response && response.data && response.data.data) {
                if (response.data.data.total > 0) {
                  this.notificationNameErrorInfo = this.$t(
                    'duplicateNotificationChannelExistError',
                  );
                  this.invalid.channelName = true;
                  this.isDisabledButton = true;
                } else {
                  this.invalid.channelName = false;
                }
              }
            })
            .catch((err) => {
              //
            });
        }
      }
    },
    buildChannelPathErrorMessage() {
      if (this.hasDuplicateItemInList) {
        return this.$t('duplicateChannelPath', [this.channelNameExtendedLable]);
      } else if (this.invalid.channelPath) {
        if (this.channelItemsApp.length == 0) {
          return this.$t('addChannelAsListIsEmpty', [
            this.channelNameExtendedLable,
          ]);
        } else if (this.channelItemsApp.length >= 50) {
          return this.$t('maximumNoOfChannelsExceedAlert');
        } else {
          return this.$t('provideValidPath', [this.channelNameExtendedLable]);
        }
      } else if (this.channelItemsApp.length == 0) {
        return this.$t('addChannelAsListIsEmpty', [
          this.channelNameExtendedLable,
        ]);
      } else
        return this.$t('provideValidPath', [this.channelNameExtendedLable]);
    },
    findChannelName(item) {
      this.channelNameExtendedLable = item.msg;
      this.channelType = item.key;
      this.placeHolderTitle = item.placeHolder;
    },
    actionOnChannelPath(item) {
      if (item.type === 'delete') {
        this.channelItemsApp = this.channelItemsApp.filter(function (i) {
          return i.name !== item.item.name;
        });
      }
    },
    handleClose() {
      this.setShowAddChannel(false);
    },
    display() {
      this.clear();
      this.setCurrentChannel({});
      this.setShowAddChannel(true);
    },
    hide(evt) {
      if (evt.trigger === 'backdrop') {
        evt.preventDefault();
        this.setShowAddChannel(false);
      }
    },
    selectChannel(item) {
      this.findChannelName(item);
      this.channelSelected = item;
      this.channelItemsApp = [];
      this.invalid.channelPat = false;
      this.channelPath = '';
    },
    formValid() {
      this.clearValidations();
      if (this.channelName === '' || this.channelName.length > 50) {
        this.invalid.channelName = true;
      }

      if (!this.channelType) {
        this.invalid.channelType = true;
      }

      if (this.channelPath) {
        if (!this.channelItemsApp.length > 0) {
          this.invalid.channelPath = true;
        }
      }
      if (!this.channelItemsApp.length > 0) {
        this.invalid.channelPath = true;
      }

      if (
        this.enableWebhookTemplate &&
        (!validateJson(this.dataTemplate) ||
          this.validateTemplateArrayProperty(this.dataTemplate))
      ) {
        this.invalidDataTemplate = true;
      }
    },
    clearValidations() {
      (this.invalid.channelName = false),
        (this.invalid.channelType = false),
        (this.invalid.channelPath = false);
    },

    validateChannelPath() {
      this.invalid.channelPath = false;
      switch (this.channelType) {
        case 'email':
          if (!validateEmail(this.channelPath)) {
            this.invalid.channelPath = true;
            return false;
          }
          return true;
        case 'slack':
          if (!validateURL(this.channelPath, this.channelType)) {
            this.invalid.channelPath = true;
            return false;
          }
          return true;
        case 'webhook':
          if (!validateURL(this.channelPath, this.channelType)) {
            this.invalid.channelPath = true;
            return false;
          }
          return true;
      }
    },
    addChannelPath() {
      if (this.channelItemsApp.length >= 50) {
        this.invalid.channelPath = true;
        return;
      }
      this.invalid.channelPath = false;
      this.hasDuplicateItemInList = false;
      if (this.validateChannelPath()) {
        var duplicate = this.channelItemsApp.filter(
          (e) => e.name === this.channelPath,
        );
        if (duplicate.length == 0) {
          this.channelItemsApp.push({ name: this.channelPath });
          this.channelPath = '';
        } else {
          this.hasDuplicateItemInList = true;
          this.validateChannelPath();
          // this.channelNameExtendedLable = this.$t('emailAddress');
          this.invalid.channelPath = true;
        }
      }
    },

    clear() {
      this.channelName = '';
      // this.channelSelected = this.channelList[0];
      this.channelPath = '';
      // this.placeHolderTitle = this.$t('addEmailAddress');
      // this.channelNameExtendedLable = this.$t('emailAddress');
      // this.channelType = 'email';
      this.channelItemsApp = [];
      this.clearValidations();
      this.dataTemplate = getPrettyJSONStr(
        this.isTagging ? defaultTaggingWebhookTemplate : defaultWebHookTemplate,
      );
    },
    async submitForm() {
      this.isDisabledButton = true;
      this.formValid();
      if (
        !this.invalid.channelName &&
        !this.invalid.channelType &&
        !this.invalidDataTemplate &&
        !this.invalid.channelPath
      ) {
        var clone = JSON.parse(JSON.stringify({}));
        if (this.updateButtonText === this.$t('update')) {
          this.updatingChannelRecord = false;
          const createdByUser = this.getCurrentChannel.createdBy;
          const _channelId = this.getCurrentChannel.channelId;
          clone.channelId = _channelId;
          clone.type = this.getCurrentChannel.type;
          clone.createdAt = this.getCurrentChannel.createdAt;
          // clone.lastUpdatedAt =this.getCurrentChannel.lastUpdatedAt
          clone.channelName = this.channelName;
          clone.createdBy = createdByUser;
          clone.lastUpdatedBy =
            this.userInfoGetter.firstName + ' ' + this.userInfoGetter.lastname;
          clone.values = this.channelItemsApp.map((item) => item.name);
          clone.template =
            this.channelType === 'webhook' ? this.dataTemplate : undefined;
          clone.templateType = this.isTagging
            ? TAGGING_TEMPLATE_TYPE
            : STANDARD_TEMPLATE_TYPE;
        } else {
          clone.channelType = this.channelType;
          clone.channelPath = this.channelPath;
          clone.channelName = this.channelName;
          clone.type = this.channelType.toUpperCase();
          clone.lastUpdatedBy =
            this.userInfoGetter.firstName + ' ' + this.userInfoGetter.lastname;
          clone.createdBy =
            this.userInfoGetter.firstName + ' ' + this.userInfoGetter.lastname;
          clone.values = this.channelItemsApp.map((item) => item.name);
          clone.template =
            this.channelType === 'webhook' ? this.dataTemplate : undefined;
          clone.templateType = this.isTagging
            ? TAGGING_TEMPLATE_TYPE
            : STANDARD_TEMPLATE_TYPE;
        }
        await this.SAVE_ALERT_RULE_CHANNEL(clone)
          .then((resp) => {
            if (resp.success && !this.isSecondaryPopup) {
              this.setShowAddChannel(false);
              this.setCurrentChannel({});
              this.setRefreshChannels(true);
              this.clear();
              this.itemsApp = [];
              notificationSucess(resp.message);
            } else if (resp.success && this.isSecondaryPopup) {
              this.setShowAddChannel(false);
              this.setCurrentChannel({});
              this.setRefreshChannels(true);
              this.clear();
              this.itemsApp = [];
              console.info('secondary popup');
            } else {
              this.setShowAddChannel(true);
              notificationError(resp.message);
            }
          })
          .catch((ex) => {
            console.error(ex);
          })
          .finally(() => {
            this.isDisabledButton = false;
            this.$emit('nccStatus', true);
          });
      }
    },

    getDefaultChannelType() {
      return this.channelList[0];
    },
    findPlaceholder(channelType) {
      switch (channelType) {
        case 'email':
          this.channelNameExtendedLable = this.$t('emailAddress');
          this.placeHolderTitle = this.$t('addEmailAddress');
          break;
        case 'slack':
          this.placeHolderTitle = this.$t('addSlackURL');
          this.channelNameExtendedLable = this.$t('slackURL');
          break;
        case 'webhook':
          this.placeHolderTitle = this.$t('addWebhookURL');
          this.channelNameExtendedLable = this.$t('webbookURL');
      }
      this.buildChannelPathErrorMessage();
    },
    getCurrentChannelData() {
      var _new = this.getCurrentChannel;
      this.clear();
      if (_new.channelId) {
        this.isEdit = true;
        this.isTagging = _new.templateType === TAGGING_TEMPLATE_TYPE;
        this.isDisabled = true;
        this.updatingChannelRecord = true;
        this.updateButtonText = this.$t('update');
        this.channelName = _new.channelName;
        this.channelType = _new.type.toLowerCase();
        this.channelSelected =
          this.channelType.charAt(0).toUpperCase() + this.channelType.slice(1);
        var _temp = [];
        _new.values.forEach((element) => {
          _temp.push({ name: element });
        });
        this.channelItemsApp = _temp;
        this.dataTemplate = _new.template
          ? getPrettyJSONStr(_new.template)
          : '';
      } else this.updateButtonText = this.$t('save');
      this.findPlaceholder(this.channelType);
    },
    onDataTemplateChange(val) {
      this.dataTemplate = val;
      if (this.invalidDataTemplate) {
        this.invalidDataTemplate = false;
        this.isDisabledButton = false;
      }
    },
    onTaggingChange(val) {
      this.isTagging = val;
      this.dataTemplate = getPrettyJSONStr(
        val ? defaultTaggingWebhookTemplate : defaultWebHookTemplate,
      );
    },
    validateTemplateArrayProperty(val) {
      this.arrayDataTemplateErrMsg = '';
      const dataTemplateObj = jsonParser(val);
      const propertiesWithMulitElArray = Object.keys(dataTemplateObj).filter(
        (key) =>
          Array.isArray(dataTemplateObj[key]) &&
          dataTemplateObj[key].length > 1,
      );

      this.arrayDataTemplateErrMsg =
        propertiesWithMulitElArray.length > 0
          ? this.$t('alert.arrayDataTemplateErrMsg', {
              property: propertiesWithMulitElArray.join(', '),
            })
          : '';

      return this.arrayDataTemplateErrMsg.length > 0;
    },
  },
  mounted: function () {
    this.channelName = '';
    this.channelSelected = this.channelList[0];
    this.channelPath = '';
    this.placeHolderTitle = this.$t('addEmailAddress');
    this.channelNameExtendedLable = this.$t('emailAddress');
    this.channelType = 'email';
    this.channelSelected = this.getDefaultChannelType();
    this.getCurrentChannelData();
  },
  watch: {
    ...mapState('channelState/overview', ['showAddChannel']),
    channelName() {
      this.isDisabledButton = false;
    },
    channelPath(newVal, oldVal) {
      if (/\s/g.test(newVal)) {
        this.invalid.channelPath = true;
      } else {
        this.invalid.channelPath = false;
        if (this.invalid.channelName) this.isDisabledButton = true;
        else this.isDisabledButton = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.d-flex {
  display: flex !important;
}
.modalRow {
  padding-top: 2.5rem;
  padding-left: 2.5rem;
  color: $font-primary;
  width: 32.18rem;
  text-align: left;
}
footer > div > .modal-footer {
  padding-left: none !important;
}
.modal-body {
  padding: 0rem !important;
}
.row-only-table-box {
  overflow-y: scroll;
  //  overflow-x: scroll !important;
  max-height: 11em;
}
.modalCol {
  padding-left: 1.25rem;
  font-family: $semi-bold !important;
}
.modalOption {
  padding-top: 0.9375rem;
  max-width: 18.75rem;
  font-family: $regular !important;
}
.modalSub2 {
  padding-top: 0.75rem;
  font-size: 0.75rem;

  font-family: $regular !important;
  max-width: 18.75rem;
}
.modalSub {
  padding-top: 0rem;
  font-size: 0.75rem;
  font-family: $regular !important;
  max-width: 24.75rem;
}
.modalFootRow {
  padding-left: 1.25rem;
  font-family: $regular !important;
}
.modalFootCol {
  padding-left: 0.625rem;
}
.validation {
  color: $poor;
  font-family: $regular !important;
}

@media screen and (max-width: 1199px) {
  .m-body {
    font-size: 12px;
  }
}

@media screen and (min-width: 1200px) {
  .m-body {
    font-size: 14px;
  }
}
@media screen and (min-width: 1600px) {
  .m-body {
    font-size: 16px;
  }
}
@media screen and (min-width: 1900px) {
  .m-body {
    font-size: 18px;
  }
}
.add-btn {
  border: none;
  background: none;
  margin: 0rem -0.5rem 0rem 0.2rem;
  @include svg-fill-pointer($color-brand-accent);
}
.channel-path {
  color: $font-primary !important;
  ::-webkit-input-placeholder {
    color: $font-primary;
  }
}
.channel-modal-body {
  height: 70vh;
  overflow-y: scroll;
}
.fields-and-table-box {
  display: flex;
}
.channel-form-fields-box {
  flex: 3;
}
.channel-form-table-box {
  flex: 2;
  margin-left: 1rem;
  margin-right: 1rem;
  min-height: 52rem;
}
.data-field-box {
  margin-top: 1.5rem;
}
.data-label-field-box {
  @include flex-center-justify(space-between);
  margin-bottom: 0.5rem;
}
.data-tag-toggle-box {
  @include flex-center-vert;
  font-size: 1rem;
}
.toggle-tag-elem {
  transform: scale(0.75);
}
.add-name-and-type {
  display: flex;
  align-items: flex-start;
}
.channel-type-box {
  margin-left: 1rem;
}
.add-channel-footer {
  @include flex-center-justify(flex-end);
}
.noti-add-channel-info {
  margin: -0.25em 0em 1em 0em;
  font-size: 0.875em;
}
.noti-add-channel-type-err-msg {
  width: 35em;
  font-size: 0.875em;
  color: $poor;
}
:deep(.toggle-label) {
  min-width: 0rem;
  margin: 0rem 0.3rem;
}
</style>
